import { render, staticRenderFns } from "./noticesDetail.vue?vue&type=template&id=550b8aae&scoped=true&"
import script from "./noticesDetail.vue?vue&type=script&lang=js&"
export * from "./noticesDetail.vue?vue&type=script&lang=js&"
import style0 from "./noticesDetail.vue?vue&type=style&index=0&id=550b8aae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b8aae",
  null
  
)

export default component.exports